import moment from 'moment';
export class DateUtils {
  public static changeFormatDate(value: Date) {
    if (value) {
      return moment(value).format('YYYY/MM/DD');
    } else {
      return '';
    }
  }

  /**
   * 日付フォーマット
   * YYYY-MM-DD HH:mm
   * @param value
   */
  public static changeFormatDateTime(value: Date) {
    if (value) {
      return moment(value).format('YYYY-MM-DD HH:mm');
    } else {
      return '';
    }
  }

  /**
   * 日付フォーマット
   * YYYY/MM/DD
   * @param value
   */
  public static convertStringToFormatDate(value: string) {
    if (value) {
      return moment(value).format('YYYY/MM/DD');
    } else {
      return '';
    }
  }

  /**
   * 日付フォーマット
   * YYYY-MM-DD
   * @param value
   */
  public static convertStringToFormatDate2(value: string) {
    if (value) {
      return moment(value).format('YYYY-MM-DD HH:mm');
    } else {
      return '';
    }
  }

  /**
   * 日付フォーマット
   * YYYY/MM/DD HH:mm
   * @param value
   */
  public static changeFormatDateTime2(value: string) {
    if (value) {
      return moment(value).format('YYYY/MM/DD HH:mm');
    } else {
      return '';
    }
  }

  public static convertStringToDatetime(value: string): Date {
    if (value) {
      return moment(value, 'YYYY-MM-DD HH:mm').toDate();
    } else {
      return null;
    }
  }

  public static toUTCDatetime(value: string | Date): string {
    if (value) {
      return moment.utc(value).format('YYYY-MM-DD HH:mm');
    } else {
      return '';
    }
  }

  public static toUTCDate(value: string | Date): Date {
    if (value) {
      return moment(value)
        .add(9, 'h')
        .toDate();
    } else {
      return null;
    }
  }

  // 現在の年を取得
  public static currentYear(value: Date): number {
    return moment(value).year();
  }

  // 現在の年度を取得
  public static currentSchoolYear(value: Date): number {
    return [1, 2, 3].includes(moment(value).month() + 1) ? moment(value).year() - 1 : moment(value).year();
  }
}
